import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=75edfa6a&scoped=true"
import script from "./custom-select.vue?vue&type=script&lang=js"
export * from "./custom-select.vue?vue&type=script&lang=js"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=75edfa6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75edfa6a",
  null
  
)

export default component.exports